import {
    RECEIVE_COURSE_SECTIONS,
    RECEIVE_COURSE_SECTION,
    REMOVE_COURSE_SECTION,
  } from "../actions/courseSections_actions";
  
  const courseSectionsReducer = (state = {}, action) => {
    Object.freeze(state);
    const newState = { ...state };
  
    switch (action.type) {
      case RECEIVE_COURSE_SECTIONS:
        return action.sections.reduce((acc, section) => {
          acc[section._id] = section;
          return acc;
        }, {});
  
      case RECEIVE_COURSE_SECTION:
        newState[action.section._id] = action.section;
        return newState;
  
      case REMOVE_COURSE_SECTION:
        delete newState[action.sectionId];
        return newState;
  
      default:
        return state;
    }
  };
  
  export default courseSectionsReducer;
  